import React, { createContext, useContext, useEffect, useState } from "react";
import productsData from "../data/products.json";

const ShopCartContext = createContext();
export const useShopCart = () => useContext(ShopCartContext);

export const ShopCartProvider = ({ children }) => {
  const [shopCartItems, setShopCartItems] = useState([]);

  // Load from localStorage (distinct key)
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("shopCartItems")) || [];
    setShopCartItems(stored);
  }, []);

  // Persist changes (preserve prescription URLs and metadata in localStorage)
  useEffect(() => {
    const itemsToSave = shopCartItems.map(item => {
      const safePrescriptions = (item.prescriptions || item.existingPrescriptions || []).map(p => {
        if (typeof p === 'string') return p;
        return {
          name: p.name || 'Prescription Document',
          type: p.type || (typeof p.data === 'string' && p.data.endsWith('.pdf') ? 'application/pdf' : 'image/jpeg'),
          data: p.data || p.url || p,
          url: p.url || p.data || p,
          size: p.size
        };
      });
      return {
        ...item,
        prescriptions: safePrescriptions,
        existingPrescriptions: safePrescriptions
      };
    });
    try {
      localStorage.setItem("shopCartItems", JSON.stringify(itemsToSave));
    } catch (e) {
      console.error("Failed to save cart to localStorage", e);
    }
  }, [shopCartItems]);

  const addToShopCart = (item) => {
    const itemId = String(item._id || item.id || '').trim();
    if (!itemId) {
      console.error("addToShopCart called with item lacking id/_id", item);
      return;
    }
    const itemWithId = {
      ...item,
      _id: itemId,
      prescriptions: item.prescriptions || item.existingPrescriptions || []
    };
    const matchedProduct = productsData.find(p => String(p.id) === itemId || p.name === item.name);
    const itemWithPincode = {
      ...itemWithId,
      pincode: item.pincode || matchedProduct?.pincode || (item.location === "Rajajinagar" && itemId === "2" ? 560092 : null)
    };

    setShopCartItems((prev) => {
      const existing = prev.find(i => String(i._id || i.id || '').trim() === itemId);
      const qtyToAdd = item.quantity || 1;
      if (existing) {
        const mergedPrescriptions = (item.prescriptions && item.prescriptions.length > 0)
          ? item.prescriptions
          : (item.existingPrescriptions && item.existingPrescriptions.length > 0)
            ? item.existingPrescriptions
            : (existing.prescriptions || existing.existingPrescriptions || []);

        return prev.map(i => String(i._id || i.id || '').trim() === itemId ? {
          ...i,
          ...itemWithPincode,
          prescriptions: mergedPrescriptions,
          existingPrescriptions: mergedPrescriptions,
          quantity: (i.quantity || 0) + qtyToAdd
        } : i);
      }
      return [...prev, { ...itemWithPincode, quantity: qtyToAdd }];
    });
  };

  const removeFromShopCart = (id) => {
    if (!id) return;
    const targetId = String(id).trim();
    setShopCartItems(prev => prev.filter(i => {
      const itemMatchId = String(i._id || i.id || '').trim();
      return itemMatchId !== targetId;
    }));
  };

  const updateShopCartItem = (id, updates) => {
    if (!id) return;
    const targetId = String(id).trim();
    setShopCartItems(prev => prev.map(i => {
      const itemMatchId = String(i._id || i.id || '').trim();
      return (itemMatchId && itemMatchId === targetId) ? { ...i, ...updates } : i;
    }));
  };

  const updateShopQuantity = (productId, newQty) => {
  if (newQty <= 0) {
    removeFromShopCart(productId.toString());
  } else {
    updateShopCartItem(productId.toString(), {
      quantity: newQty,
    });
  }
};

  const clearShopCart = () => setShopCartItems([]);



  return (
    <ShopCartContext.Provider value={{
      shopCartItems,
      addToShopCart,
      removeFromShopCart,
      updateShopCartItem,
        updateShopQuantity,
      clearShopCart,
    }}>
      {children}
    </ShopCartContext.Provider>
  );
};
